import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'reporte',

  data() {
    return {
      loading: false,
      loading_f: false,

      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false,
        nro: 1
      },
    
      tabla: {
        tarjetas: [],
        data:[]
      }
    }
  },

  mounted: function () {
    $('.box').boxWidget()
  },

  methods: {

    reinicia() {
      this.tabla = {
        headers: []
      };
    },

    descargar() {
      this.to_excel_name2($('#dett').html(), 'dett', 'Día-Terminal-Lote')
    },

    consultar() {
      this.loading = true
      this.$http
        .post('/SERVER/scd/estadisticas/', {
          'a': 'diaTerminalLote',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          this.tabla.data = [];
          if (response.data.status === 1) {
       
            this.tabla.tarjetas = response.data.tarjetas
            this.tabla.data = response.data.data
          }
          this.loading = false
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/estadisticas/diaTerminalLote/reporte/index.js